import React, { Component } from 'react';
// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/nucleo-icons-page-styles.css";

// pages for this kit
import Index from "views/Index.js";
import LoginPage from "views/examples/LoginPage.js";
import InfoPage from "views/examples/InfoPage";
import ProductPage from "views/examples/ProductPage";
import ProfilePage from "views/examples/ProfilePage.js";
import ContactPage from "views/examples/ContactPage";
import Questions from "views/examples/Questions";
import Options from "views/examples/Options";
import { appUrl } from './config';

class App extends Component {

    constructor(props) {
        super(props);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.state = {
            loading: true,
            user: {},
            view: "index",
            admin: false,
            userstatus: false,
            info: [],
            products:[],
            productselected:{}
        }
    }
    handleStateChange(name, e) {
        console.log("handleStateChange", name, e, this.state)

        if (name == "view") {
            this.setState({ view: e });
        } else if (name == "user") {
            this.setState({ user: e });
        } else if (name == "admin") {
            this.setState({ admin: e });
        } else if (name == "userstatus") {
            this.setState({ userstatus: e });
        } else if (name == "info") {
            this.getInfo()
        } else if (name == "services") {
            this.setState({ view: "services", productselected:e });
        }
    }

    componentDidMount() {
        this.getInfo()
        this.getProducts()
    }
    getInfo() {
        fetch(appUrl + '/getinfo', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log("getinfo", data.info.length)
                if (data.success) {
                    var dic = []
                    console.log("dicapp", data.info)
                    this.setState({ info: data.info })
                } else {
                }
            });
    }

    getProducts() {
        fetch(appUrl + '/getproducts', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log("getproducts", data.products)
                if (data.success) {
                    this.setState({ products: data.products })
                } else {
                }
            });
    }
    render() {
        let Ren = () => {
            if (this.state.view === 'index') {
                return <Index onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} info={this.state.info} admin={this.state.admin} />
            } else if (this.state.view === 'login') {
                return <LoginPage onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} />
            } else if (this.state.view === 'info') {
                return <InfoPage onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} info={this.state.info} admin={this.state.admin} />
            } else if (this.state.view === 'services') {
                return <ProductPage onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} info={this.state.info} admin={this.state.admin} />
            } else if (this.state.view === 'profile-page') {
                return <ProfilePage onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} admin={this.state.admin} />
            } else if (this.state.view === 'contact') {
                return <ContactPage onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} admin={this.state.admin} />
            } else if (this.state.view === 'options') {
                return <Options onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} admin={this.state.admin} />
            } else if (this.state.view === 'allquestions') {
                return <Questions onChange={this.handleStateChange} productselected={this.state.productselected} products={this.state.products} user={this.state.user} userstatus={this.state.userstatus} admin={this.state.admin} />
            }
        }
        return (
            <>
                <Ren />
            </>
        );
    }
}
export default App;